($ => {
  $(document).ready(() => {
    $('.dumel-recommended').each((idx, slider) => {
      const slidesCount = $(slider).find('.dumel-recommended__item').length;
      const maxSlidesToShow = slidesCount < 6 ? slidesCount : 6;
      $(slider).find('.dumel-recommended__items').slick({
        infinite: true,
        slidesToShow: maxSlidesToShow,
        slidesToScroll: maxSlidesToShow,
        prevArrow: $('.dumel-recommended__navigation-button--prev'),
        nextArrow: $('.dumel-recommended__navigation-button--next'),
        dots: true,
        appendDots: $('.dumel-recommended__navigation-pagin'),
        customPaging: () => {
          return;
        },
        responsive: [
          // {
          //   breakpoint: 1024,
          //   settings: 'unslick'
          // },
          {
            breakpoint: 1600,
            settings: {
              slidesToShow: slidesCount < 5 ? slidesCount : 5,
              slidesToScroll: slidesCount < 5 ? slidesCount : 5
            }
          },
          {
            breakpoint: 1300,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4
            }
          },
          {
            breakpoint: 1100,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 540,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      } as any);

      setSliderElementsPositions();
      $(window).on('resize orientationchange', () => {
        setSliderElementsPositions();
      });

      function setSliderElementsPositions() {
        const x = window.matchMedia('(max-width: 900px)');
        const navigation = $('.dumel-recommended__navigation');

        if (x.matches) {
          navigation.detach();
          const navi = $(slider).find('.dumel-recommended__footer-navigation');
          navigation.appendTo(navi);
        } else {
          navigation.detach();
          const navi = $(slider).find('.dumel-recommended__head-navigation');
          navigation.appendTo(navi);
        }

        const dots = $(slider).find('.slick-dots li');

        if (dots.length <= 1) {
          dots.hide();
        } else {
          dots.show();
        }

      }
    });
  });
})(jQuery);
